export const GET_PRODUCTS = 'get_products';
export const GET_PRODUCTS_SUCCESS = 'get_products_SUCCESS';
export const GET_PRODUCTS_FAIL = 'get_products_FAIL';

export const GET_PRODUCT = 'get_product';
export const GET_PRODUCT_SUCCESS = 'get_product_SUCCESS';
export const GET_PRODUCT_FAIL = 'get_product_FAIL';

export const GET_PRODUCT_PARTS = 'get_product_parts';
export const GET_PRODUCT_PARTS_SUCCESS = 'get_product_parts_SUCCESS';
export const GET_PRODUCT_PARTS_FAIL = 'get_product_parts_FAIL';

export const GET_THEMES = 'get_themes';
export const GET_THEMES_SUCCESS = 'get_themes_SUCCESS';
export const GET_THEMES_FAIL = 'get_themes_FAIL';

export const SET_PRODUCT = 'set_product';

export const SET_PRODUCT_PARTS = 'set_product_parts';

export const SET_CONFIGURATION = 'set_configuration';

export const SET_SAVED = 'set_saved';
export const SET_MODAL = 'set_modal';

export const SET_IMAGE_FUNC = 'set_image_func';

export const CHANGING_PRODUCT = 'changing_product';

export const QUERY_STRING = 'query_string';

export const PRE_MADE_PRODUCT = 'pre_made_product';
